import { ArrowRight, ArrowDown, Check } from "lucide-react";

export const goTo = (id) => {
  const unlocked = !!localStorage.getItem("cc_unlocked");
  const target = id || (unlocked ? "video" : "unlock");
  document.getElementById(target)?.scrollIntoView({ behavior: "smooth", block: "start" });
  if (!id && !unlocked) setTimeout(() => document.getElementById("first_name")?.focus({ preventScroll: true }), 700);
};

export const Cta = ({ children, to, id }) => (
  <button type="button" className="btn-gold" onClick={() => goTo(to)} data-testid={id}>
    {children} <ArrowRight size={18} />
  </button>
);

export const Kicker = ({ children, light }) => <p className={`kicker${light ? " light" : ""}`}>{children}</p>;

export const Big = ({ children, as: Tag = "h2", className = "" }) => <Tag className={`big ${className}`}>{children}</Tag>;

export const Lines = ({ items, className = "" }) => (
  <div className={`lines ${className}`}>{items.map((t) => <p key={t}>{t}</p>)}</div>
);

export const FlowV = ({ items, id }) => (
  <ol className="flowv" data-testid={id}>
    {items.map((it, i) => (
      <li key={i}>
        <div className="flowv-box">
          <b>{Array.isArray(it) ? it[0] : it}</b>
          {Array.isArray(it) && <span>{it[1]}</span>}
        </div>
        {i < items.length - 1 && <ArrowDown size={20} className="flowv-arrow" />}
      </li>
    ))}
  </ol>
);

export const FlowH = ({ items }) => (
  <p className="flowh">{items.map((t, i) => <span key={t}>{t}{i < items.length - 1 && <ArrowRight size={16} />}</span>)}</p>
);

export const Checks = ({ items }) => (
  <ul className="checks">{items.map((t) => <li key={t}><Check size={18} /> {t}</li>)}</ul>
);

export const Disclaimer = () => <p className="disclaimer">Individual client experience. Results vary.</p>;

export const P = ({ children }) => <p className="punch">{children}</p>;
export const Wait = ({ children }) => <p className="wait">{children}</p>;
export const Stack = ({ items }) => <div className="dstack">{items.map((t) => <p key={t}>{t}</p>)}</div>;
export const Chips = ({ items }) => <ul className="chips">{items.map((t) => <li key={t}>{t}</li>)}</ul>;
export const StepHead = ({ n, name, children }) => (
  <div className="stephead"><p className="dstep-n">{n} — {name}</p><h3 className="big">{children}</h3></div>
);
